<main class="infoscreen-container">
  <router-outlet />
</main>
